export default __webpack_public_path__ + "static/media/Information-Default.17260fea.svg";